export function safeStringify(value: unknown): string | undefined {
  try {
    return JSON.stringify(value);
  } catch {
    return 'Error: Failed to stringify value';
  }
}
